import { useField } from 'formik';

import { IMultiSelectField } from '../interfaces/IMultiSelectField';

import CloseIcon from '@/assets/CloseIcon';
import HaggleEventProductListModal from '@/components/modal/haggle-event/HaggleEventProductListModal';
import Button from '@/components/ui/button/Button';
import { useModal } from '@/hooks/useModal';
import { IBaseEntity } from '@/interfaces/api/IBaseEntity';
import { IProduct } from '@/interfaces/api/product/IProduct';

const MultiSelectModalField = <T extends IBaseEntity>({
	name,
	resources = [],
	displayField,
	...rest
}: IMultiSelectField<T>) => {
	const [field, , helpers] = useField(name);

	const values = Array.isArray(field.value) ? field.value : [];

	const handleRemove = (id: string) => {
		helpers.setValue(values.filter((item) => item.id !== id));
	};

	const {
		modal: haggleEventProductListModal,
		openModal: openHaggleEventProductListModal,
		closeModal: closeHaggleEventProductListModal,
	} = useModal({
		children: (
			<HaggleEventProductListModal
				closeModal={() => closeHaggleEventProductListModal()}
				resources={resources as unknown as IProduct[]}
				helpers={helpers}
				values={values}
				disabled={rest.disabled ?? false}
			/>
		),
		closeOnOutClick: false,
		modalBoxClassName: 'w-full max-w-6xl',
	});

	return (
		<>
			<Button
				type="button"
				size="mini"
				color="success"
				shape="rounded"
				transition="none"
				onClick={openHaggleEventProductListModal}
				data-test="button-open-products-modal"
				className="bg-purpleBrand-500 hover:bg-purpleBrand-600"
			>
				View products
			</Button>
			{haggleEventProductListModal}
			<div className="mt-2 p-2 border rounded-md max-h-40 overflow-y-auto">
				{values.length === 0 && (
					<span className="text-gray-500 text-sm">No items selected</span>
				)}
				{values.map((item) => (
					<div
						key={item.id}
						className={`flex justify-between items-center mb-1 p-1 bg-gray-100 rounded ${
							rest.disabled && 'opacity-70 hover:cursor-not-allowed'
						}`}
					>
						<span>{String(item[displayField])}</span>
						<button
							type="button"
							onClick={() => handleRemove(item.id)}
							disabled={rest.disabled}
							className={`text-red-500 hover:text-red-700 ${
								rest.disabled && 'cursor-not-allowed'
							}`}
							data-test={`remove-${name}-${item.id}`}
						>
							<CloseIcon width={20} height={20} />
						</button>
					</div>
				))}
			</div>
		</>
	);
};

export default MultiSelectModalField;
